<template>
<div>
  <button type="button" class="btn btn-success right" @click="openDialog">
    {{submitText}}
  </button>

  <b-modal v-bind:title="submitText" size="lg"
           body-class="padding-none" ok-variant=" bg-main border-radius-4px pl-3 pr-3" :hide-header="false"
           :hide-footer="false" v-model="dialogVisible" :ok-title="$t('common.save')" ok-only
           @ok="dialogVisible = false; $emit('importFile', file, action)">
    <div>
      <div>
        <b-form-file class="border-radius-4px" id="bannerData" @change="previewFile" ref="File"></b-form-file>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <b-row>
        <button @click="dialogVisible = false">Cancel</button>
        <button type="button" class="btn btn-success"  ok-only
                @ok="needReset=false; updateItemData()" @click="$emit('importFile')">Confirm</button>
      </b-row>
    </div>
  </b-modal>

</div>
</template>

<script>
  import {actions} from '../store/mutations'

  export default {
    name: 'ImportFile',
    props: {
      submitText: {
        type: String,
        default: null,
      },
      action: {
        type: String,
        default: null,
      },
    },
    data: function () {
      return {
        dialogVisible: false,
        file: null
      }
    },
    methods: {
      openDialog() {
        this.dialogVisible = true
        this.file=null
      },
      previewFile (event) {
        let input = event.target
        if (input.files && input.files[0]) {
          let reader = new FileReader()
          reader.onload = (e) => {
            this[input.id] = e.target.result
          }
          reader.readAsDataURL(input.files[0])
          this.file = input.files[0]
        }
      },
      submitFrom() {
        if(this.file !== null) {
          this.$emit('importFile', this.file, this.action)
          this.dialogVisible = false
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ImportFile.vue